export default __webpack_public_path__ + "static/media/win_icon.27ec2b64.png";